<template>
  <span style="width: 100%">
    <label-time-picker
      :format="format"
      :value-format="valueFormat"
      @focus="dateFocus"
      @blur="dateBlur"
      :type="type"
      v-bind="$attrs"
      v-on="$listeners"
      :label="label"
    >
    </label-time-picker>
  </span>
</template>

<script>
import LabelTimePicker from "@/components/label-input-v2/time-picker";
// import moment from "moment-timezone";
export default {
  name: "datePicker",
  props: {
    inputWidth: {
      required: false,
      default: "",
    },
    type: {
      type: String,
      required: false,
      default: "date",
    },
    format: {
      type: String,
      required: false,
      default: "HH:mm",
    },
    valueFormat: {
      type: String,
      required: false,
      default: "timestamp",
    },
    form: {
      type: Object,
      require: true,
      default: function () {
        return {};
      },
    },
    label: {
      type: String,
      require: false,
      default: "",
    },
  },
  data() {
    return {
      isColor: false,
    };
  },
  watch: {
    form: {
      handler(news) {
        // console.log(news.date,'71')
        if (news) {
          this.$forceUpdate();
          this.isColor = false;
        }
      },
    },
    deep: true,
  },
  methods: {
    dateFocus() {
      this.isColor = true;
      try {
        document
          .querySelectorAll(".popper__arrow")
          .forEach((item) => (item.style = `display: none`));
        document
          .querySelectorAll("th")
          .forEach((item) => (item.style = `color:#b2b6c0;`));
        document
          .querySelectorAll("td")
          .forEach(
            (item) =>
              (item.children[0].children[0].style = `font-weight: bold;`)
          );
        document
          .querySelectorAll(".el-range-editor")
          .forEach((item) => (item.style = `padding: 0 10px;`));
        document
          .querySelectorAll(".el-range-separator")
          .forEach((item) => (item.style = `display: block`));
      } catch (error) {
        //  eslint-disable-next-line
      }
    },
    dateBlur() {
      this.$forceUpdate();
      this.isColor = false;
      if (this.form) {
        // document.querySelectorAll('.el-icon-date').forEach(item => item.style = `display: block`)
        document
          .querySelectorAll(".el-range-separator")
          .forEach((item) => (item.style = `display: block`));
      } else {
        document
          .querySelectorAll(".el-icon-date")
          .forEach((item) => (item.style = `display: none`));
        document
          .querySelectorAll(".el-range-separator")
          .forEach((item) => (item.style = `display: none`));
      }
    },
  },
  components: { LabelTimePicker },
};
</script>

<style lang="scss" scoped>
span {
  display: inline-block;
  position: relative;
}
/deep/ .el-icon-circle-close {
  &::before {
    position: relative;
    top: 2px;
    content: url("../../assets/img/common-icon/icon-16-close.svg");
    background: #fff;
  }
}
/deep/ .el-icon-time {
  &::before {
    position: relative;
    top: 2px;
    content: url('./control-icon/time.svg');
  }
}
// /deep/ .popper__arrow {
//   display: none;
// }
</style>
